module.exports = {
  error(...args) {
    if (console && console.error) {
      console.error(...args);
    }
  }
};
